<template>
  <div class="page">
    <v-container grid-list-sm>
      <v-layout row wrap>
        <v-flex sm4 v-if="page && page.hide_section_list !== 'ja'" class="sum-fixed__wrapper">
          <div class="sum-fixed">
            <div v-if="!loading" class="col-inner col-highlight sum sum-active">
              <div class="sum-type">{{ translate['Einleitung'][lang] }}</div>
              <h3 class="ffs sum-title h3pad">
                <a v-if="page" href="#g-main-content-title" v-html="page.title.rendered" v-on:click="selectedSection"></a>
              </h3>
              <div class="ffs sum-excerpt" v-html="page.excerpt.rendered" v-if="page.hide_excerpt !== 'ja'"></div>
            </div>
            <div v-if="sections" v-for="section in sections" :key="section.id" class="col-inner col-highlight sum">
              <div class="sum-type-section">{{ translate['Abschnitt'][lang] }}</div>
              <a :href="'#' + section.id" v-on:click="selectedSection">{{ section.textContent }}</a>
            </div>
          </div>
        </v-flex>
        <v-flex sm8 class="max-width--960 sec_col flex-grow-1 flex-shrink-0">
          <div v-if="!loading" class="col-inner col-highlight">
            <h1 v-if="page" id="g-main-content-title" v-html="page.title.rendered"></h1>
            <div v-if="page && page.hide_excerpt !== 'ja'" class="excerpt" v-html="page.excerpt.rendered"></div>
            <CollectionCatalogues v-if="pageName === 'quellen' || pageName === 'sources'" :lang="lang">
            </CollectionCatalogues>
            <br>
            <div v-if="page" class="ffs" v-html="page.content.rendered"></div>
            <Archivbestand v-if="(pageName === 'quellen' || pageName === 'sources')" :lang="lang"></Archivbestand>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CollectionCatalogues from '@/static/Collection-catalogues.vue'
import Archivbestand from '@/components/pages/partials/Archivbestand.vue'

export default {
  name: 'Page',
  components: {
    CollectionCatalogues,
    Archivbestand
  },
  data () {
    return {
      msg: 'Rudolf Mosse und seine Familie',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      page: {},
      sections: [],
      loading: true
    }
  },
  created () {
    if (
      this.$route.params.slug === 'sources' ||
      this.$route.params.slug === 'talks-and-publikations' ||
      this.$route.params.slug === 'rudolf-mosse-and-his-family' ||
      this.$route.params.slug === 'rudolf-mosses-art-collection' ||
      this.$route.params.slug === 'the-dispossession-of-the-lachmann-mosse-family' ||
      this.$route.params.slug === 'the-mosse-art-research-initiative-mari' ||
      this.$route.params.slug === 'infos' ||
      this.$route.params.slug === 'press' ||
      this.$route.params.slug === 'imprint' ||
      this.$route.params.slug === 'contact-information'
    ) {
      this.$store.commit('setLang', 'en')
      this.$store.commit('switchPagesLang', 'en')
    }
  },
  mounted () {
    let sum = document.querySelector('.sum-fixed')
    let isScrolling

    if (this.pages.length > 0) {
      this.loading = false
      this.setPage(this.$route.params.slug)
      this.setSections()
      this.handleSubNav(document.querySelector('.sum-fixed'))
      this.selectedFootnote()
    }

    this.handleSubNav(sum)

    window.addEventListener('scroll', function (event) {
      window.clearTimeout(isScrolling)
      isScrolling = setTimeout(function () {
        let offset = document.documentElement.scrollTop || window.pageYOffset
        sum.style.top = offset + 'px'
      }, 30)
    }, false)
  },
  computed: {
    ...mapGetters([
      'pages',
      'translate',
      'lang'
    ]),
    pageName () {
      return this.$route.params.slug || ''
    }
  },
  watch: {
    pages: function () {
      if (this.pages.length > 0) {
        this.loading = false
        this.setPage(this.$route.params.slug)
        this.setSections()
        this.handleSubNav(document.querySelector('.sum-fixed'))
        this.selectedFootnote()
      } else {
        this.loading = true
      }
    },
    '$route' (to, from) {
      this.setPage(to.params.slug)
      this.setSections()
      this.handleSubNav(document.querySelector('.sum-fixed'))
      this.selectedFootnote()
    }
  },
  methods: {
    selectedFootnote () {
      this.$nextTick(() => {
        let fns = document.querySelectorAll('.footnote_link')
        fns.forEach(fn => {
          fn.addEventListener('click', (event) => {
            event.preventDefault()
            let id = event.target.hash.substr(1)
            if (id && id.length > 0) {
              let target = document.getElementById(id)
              target.scrollIntoView({
                block: 'start',
                inline: 'nearest',
                behavior: 'smooth'
              })
            }
          })
        })
      })
    },
    selectedSection (event) {
      event.preventDefault()
      let id = event.target.hash.substr(1)
      if (id && id.length > 0) {
        let target = document.getElementById(id)
        target.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth'
        })
      }
    },
    setPage (slug) {
      this.page = this.pages.find(page => page.slug === this.$route.params.slug)
    },
    setSections () {
      let el = document.createElement('html')
      if (this.page) {
        el.innerHTML = this.page.content.rendered
      }
      this.sections = el.getElementsByTagName('h2')
    },
    handleSubNav (sum) {
      function setSubnav () {
        let windowWidth = window.innerWidth ||
          document.documentElement.clientWidth ||
          document.getElementsByTagName('body')[0].clientWidth
        let windowHeight = window.innerHeight ||
          document.documentElement.clientHeight ||
          document.getElementsByTagName('body')[0].clientHeight

        if (windowWidth >= 600) {
          sum.style.display = 'block'
        } else {
          sum.style.display = 'none'
        }
        sum.style.height = (windowHeight - 48) + 'px'
      }
      if (sum) {
        setSubnav()
      }
      window.onresize = function (event) {
        setSubnav()
        sum.style.top = document.documentElement.scrollTop + 'px'
      }
    }
  }
}
</script>
<style lang="scss">
h3.h3pad {
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Page.vue